import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import { READ_STATUS_MODEL_LIST } from "../actions/types"

import {
  readStatusModelSuccess,
  readStatusModelError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

function* request(action) {
  const { id } = action.config
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/event-status`,
      params: {
        eventTypeId: id,
      },
    })

    yield put(readStatusModelSuccess(response))
  } catch (error) {
    yield put(readStatusModelError(error))
  }
}

export default function* allStatusesSaga() {
  yield takeEvery(READ_STATUS_MODEL_LIST, request)
}
